import { BASE_URL_SETTING } from '../../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'
import { TAB_MAILING_LIST_RECIPIENT } from '~/constants/tab/customer-mailing-list/tab.constants'

const base = `${BASE_URL_SETTING}/customer-mailing-list`

export const SETTINGS_MAILING_LIST_CREATE: Route = {
  path: `${base}/{id}/create`
}

export const SETTINGS_MAILING_LIST_EDIT: Route = {
  path: `${base}/{id}/edit/{id_mailing}`
}

export const SETTINGS_MAILING_LIST_IMPORT: Route = {
  path: `${base}/{id}/import/{id_mailing}`
}

export const SETTINGS_MAILING_LIST_EDIT_MAILING_LIST_RECIPIENT: Route = {
  path: `${base}/{id}/edit/{id_mailing}?tab=${TAB_MAILING_LIST_RECIPIENT}`
}

export const SETTINGS_MAILING_LIST_RECIPIENT_CREATE: Route = {
  path: `${base}/{id}/recipient/{id_mailing}/create`
}

export const SETTINGS_MAILING_LIST_RECIPIENT_EDIT: Route = {
  path: `${base}/{id}/recipient/{id_mailing}/edit/{id_recipient}?email={email}`
}
